/**
 * 所以的Excel下载都掉这个方法，预防修改下载的方法或者处理兼容性问题
*/
// import qs from 'qs'
import { downExcel, downExcel2 } from '@/api/common'

export default {
  methods: {
    downExcel (url, name = '数据表格', params) {
      downExcel(url, params).then(res => {

        const blob = new Blob([res ? '\ufeff' + res : ''], { type: 'text/csv,charset=UTF-8' })
        const url = window.URL.createObjectURL(blob, { type: 'text/plain' })
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        const fileName = name + '.csv'
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    }
  }
}

export const downExcelMixin = {
  methods: {
    downExcel (url, name = '数据表格', params) {
        downExcel2(url, params).then(res => {
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        const fileName = name + '.xlsx'
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    downExcelCSV (url, name = '数据表格', params) {
      downExcel(url, params).then(res => {
        const blob = new Blob([res ? '\ufeff' + res : ''], { type: 'text/csv,charset=UTF-8' })
        const url = window.URL.createObjectURL(blob, { type: 'text/plain' })
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        const fileName = name + '.csv'
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    }
  }
}
